import { useContext, createContext } from 'react';

const NameContext = createContext();

const useGroupPlanName = () => useContext(NameContext);

export { NameContext, useGroupPlanName };
